import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  inputField: {
    width: '100px'
  },

}));
export default styles;
